// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconElectronicsPath = 'm15.417 1.446-3.19 3.19 2.716 2.716 3.19-3.19 1.414 1.414-3.19 3.19 1.688 1.689a1 1 0 0 1 0 1.414l-4.603 4.603a7.062 7.062 0 0 1-9.176.696L1.434 20 .02 18.586l2.819-2.82a7.062 7.062 0 0 1 .618-9.278l4.604-4.604a1 1 0 0 1 1.414 0l1.338 1.338 3.19-3.19 1.414 1.414Zm-2.46 9.673L8.81 6.972 7.395 8.386l4.148 4.147 1.414-1.414Zm-4.19-7.113L4.872 7.902a5.06 5.06 0 0 0 7.157 7.156l3.896-3.896-7.156-7.156Z';
var IconElectronics = baseIcon('IconElectronics', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconElectronicsPath
});
export default IconElectronics;
//# sourceMappingURL=index.js.map